import axios from 'axios'
import { resolveRelativeApiPath } from './serverContext'
import { expiredLoginPath, shouldExpireSessionForRequest, SESSION_EXPIRED_EVENT, SESSION_NOTICE_KEY } from './authExpiry'
import { clearCurrentTenantSensitiveStorage } from './tenantStorage'
import { clearAuthToken, getAuthToken } from './tokenStorage'

const api = axios.create({ baseURL: '/api', withCredentials: true })

api.interceptors.request.use((config) => {
  const method = String(config.method || 'get').toLowerCase()
  if (typeof navigator !== 'undefined' && navigator.onLine === false && !['get', 'head', 'options'].includes(method)) {
    const error = new Error('Çevrimdışıyken yönetim işlemi gönderilemez. Bağlantı geldikten sonra yeniden deneyin.') as Error & {
      code?: string
      response?: { status: number; data: { detail: string } }
      config?: typeof config
    }
    error.code = 'SERVERNOX_OFFLINE'
    error.response = { status: 0, data: { detail: error.message } }
    error.config = config
    throw error
  }
  const token = getAuthToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  if (config.url) config.url = resolveRelativeApiPath(config.url)
  return config
})

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const requestUrl = String(err?.config?.url || '')
    const isLoginRequest = requestUrl.includes('/auth/login') || requestUrl.includes('/auth/login/2fa') || requestUrl.includes('/auth/passkeys/login/') || requestUrl.includes('/auth/sso/')
    const status = err?.response?.status
    const detail = err?.response?.data?.detail
    const token = getAuthToken()
    const requestHeaders = err?.config?.headers
    const requestAuthorization = typeof requestHeaders?.get === 'function'
      ? requestHeaders.get('Authorization') || requestHeaders.get('authorization')
      : requestHeaders?.Authorization || requestHeaders?.authorization

    if (!isLoginRequest && shouldExpireSessionForRequest(status, detail, requestAuthorization, token)) {
      try {
        clearCurrentTenantSensitiveStorage()
        clearAuthToken()
        localStorage.removeItem('user')
        localStorage.removeItem('role')
        sessionStorage.setItem(SESSION_NOTICE_KEY, 'Oturumunuzun süresi doldu. Güvenliğiniz için yeniden giriş yapın.')
        window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT))
        if (window.location.pathname !== '/login') {
          window.location.replace(expiredLoginPath(
            window.location.pathname,
            window.location.search,
            window.location.hash,
          ))
        }
      } catch {
        // Depolama erişimi engellense bile asıl HTTP hatası çağırana ulaşmalı.
      }
    }

    return Promise.reject(err)
  }
)

export default api
